<div class="page-container">
  <div class="grid-container">
    <!-- 2x2 Grid for main components -->
    <app-dashboard-frame class="spotlight" title="What's New ?" [showHoverOver]="false">
      <app-asklearnshare class="dash-asklearnshare"></app-asklearnshare>
    </app-dashboard-frame>

    <app-dashboard-frame class="idea" title="Idea Center" [showHoverOver]="false" >
      <app-ideaword></app-ideaword>
    </app-dashboard-frame>

    <app-dashboard-frame class="search" title="Search" [showHoverOver]="false">
      <app-search-dash></app-search-dash>
    </app-dashboard-frame>

    <!-- Latest News in its original position (right side, spanning multiple rows) -->
    <app-dashboard-frame class="latest-news" title="Latest News And Publications" [showHoverOver]="false">
      <app-latest-news></app-latest-news>
    </app-dashboard-frame>

    <!-- Pinned tiles spanning across bottom -->
    <app-dashboard-frame class="pinned" title="My Pinned Items">
      <div class="pinned-section">
        <app-pinned-tiles></app-pinned-tiles>
      </div>
    </app-dashboard-frame>
  </div>
</div>
